<div class="auth-container">
  <div class="auth-card">
    <!-- Logo & Header -->
    <div class="auth-header">
      <div class="logo-container">
        <img src="assets/logo/bee.png" alt="BizzWeaver" class="auth-logo" />
      </div>
      <h1 class="auth-title">{{ 'REGISTER_TITLE' | translate }}</h1>
      <p class="auth-subtitle">{{ 'REGISTER_SUBTITLE' | translate }}</p>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="error-banner">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <span>{{ errorMessage | translate }}</span>
      </div>
    }

    <section class="provider-section" aria-label="Social sign-up">
      <button type="button" class="provider-button" [disabled]="isLoading || isProviderLoading" (click)="continueWithGoogle()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M21.8 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.8 3.2-4.4 3.2-7.3Z"/><path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.5l-3.2-2.5c-.9.6-2 .9-3.4.9-2.6 0-4.8-1.7-5.6-4H3.1v2.6A10 10 0 0 0 12 22Z"/><path fill="#FBBC05" d="M6.4 13.9a6 6 0 0 1 0-3.8V7.5H3.1a10 10 0 0 0 0 9l3.3-2.6Z"/><path fill="#EA4335" d="M12 6.1c1.5 0 2.9.5 4 1.6l3-3A10 10 0 0 0 3.1 7.5l3.3 2.6c.8-2.3 3-4 5.6-4Z"/></svg>
        Continue with Google
      </button>
      <div class="auth-divider" aria-hidden="true"><span>or create an account with email</span></div>
    </section>

    <!-- Register Form -->
    <form (ngSubmit)="onSubmit()" class="auth-form">
      <!-- Name Field -->
      <div class="form-group">
        <label for="name" class="form-label">{{ 'NAME' | translate }} <span class="optional">{{ 'OPTIONAL' | translate }}</span></label>
        <div class="input-wrapper">
          <ion-icon name="person-outline" class="input-icon"></ion-icon>
          <input
            type="text"
            id="name"
            [(ngModel)]="name"
            name="name"
            class="form-input"
            [placeholder]="'NAME_PLACEHOLDER' | translate"
            autocomplete="name"
            />
          </div>
        </div>

        <!-- Email Field -->
        <div class="form-group">
          <label for="email" class="form-label">{{ 'EMAIL' | translate }}</label>
          <div class="input-wrapper" [class.invalid]="!isEmailValid() && email.length > 0">
            <ion-icon name="mail-outline" class="input-icon"></ion-icon>
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              class="form-input"
              [placeholder]="'EMAIL_PLACEHOLDER' | translate"
              autocomplete="email"
              required
              />
            </div>
            @if (!isEmailValid() && email.length > 0) {
              <span class="error-text">
                {{ 'INVALID_EMAIL' | translate }}
              </span>
            }
          </div>

          <!-- Password Field -->
          <div class="form-group">
            <label for="password" class="form-label">{{ 'PASSWORD' | translate }}</label>
            <div class="input-wrapper" [class.invalid]="password.length > 0 && !allRequirementsMet">
              <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                [(ngModel)]="password"
                name="password"
                class="form-input"
                [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
                autocomplete="new-password"
                (input)="onPasswordChange()"
                required
                />
                <button
                  type="button"
                  class="password-toggle"
                  (click)="togglePasswordVisibility()"
                  >
                  <ion-icon [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                </button>
              </div>

              <!-- Password Requirements -->
              @if (password.length > 0) {
                <div class="password-requirements">
                  <div class="requirement" [class.met]="passwordRequirements.minLength">
                    <ion-icon [name]="passwordRequirements.minLength ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    <span>{{ 'PASSWORD_MIN_LENGTH' | translate }}</span>
                  </div>
                  <div class="requirement" [class.met]="passwordRequirements.hasUppercase">
                    <ion-icon [name]="passwordRequirements.hasUppercase ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    <span>{{ 'PASSWORD_UPPERCASE' | translate }}</span>
                  </div>
                  <div class="requirement" [class.met]="passwordRequirements.hasLowercase">
                    <ion-icon [name]="passwordRequirements.hasLowercase ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    <span>{{ 'PASSWORD_LOWERCASE' | translate }}</span>
                  </div>
                  <div class="requirement" [class.met]="passwordRequirements.hasNumber">
                    <ion-icon [name]="passwordRequirements.hasNumber ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    <span>{{ 'PASSWORD_NUMBER' | translate }}</span>
                  </div>
                  <div class="requirement" [class.met]="passwordRequirements.hasSpecialChar">
                    <ion-icon [name]="passwordRequirements.hasSpecialChar ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    <span>{{ 'PASSWORD_SPECIAL' | translate }}</span>
                  </div>
                </div>
              }
            </div>

            <!-- Confirm Password Field -->
            <div class="form-group">
              <label for="confirmPassword" class="form-label">{{ 'CONFIRM_PASSWORD' | translate }}</label>
              <div class="input-wrapper" [class.invalid]="!passwordsMatch() && confirmPassword.length > 0">
                <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  id="confirmPassword"
                  [(ngModel)]="confirmPassword"
                  name="confirmPassword"
                  class="form-input"
                  [placeholder]="'CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                  autocomplete="new-password"
                  required
                  />
                  <button
                    type="button"
                    class="password-toggle"
                    (click)="toggleConfirmPasswordVisibility()"
                    >
                    <ion-icon [name]="showConfirmPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                  </button>
                </div>
                @if (!passwordsMatch() && confirmPassword.length > 0) {
                  <span class="error-text">
                    {{ 'PASSWORDS_NOT_MATCH' | translate }}
                  </span>
                }
              </div>

              <!-- Terms & Conditions -->
              <div class="form-group">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="acceptTerms"
                    name="acceptTerms"
                    class="checkbox-input"
                    />
                    <span class="checkbox-custom"></span>
                    <span class="checkbox-text">
                      {{ 'ACCEPT_TERMS_PREFIX' | translate }}
                      <a href="/terms" target="_blank" class="terms-link">{{ 'TERMS_OF_SERVICE' | translate }}</a>
                      {{ 'AND' | translate }}
                      <a href="/privacy" target="_blank" class="terms-link">{{ 'PRIVACY_POLICY' | translate }}</a>
                    </span>
                  </label>
                </div>

                <!-- Submit Button -->
                <button
                  type="submit"
                  class="submit-button"
                  [disabled]="isLoading || !isFormValid()"
                  >
                  @if (isLoading) {
                    <ion-spinner name="crescent"></ion-spinner>
                  }
                  @if (!isLoading) {
                    <span>
                      <ion-icon name="create-outline"></ion-icon>
                      {{ 'REGISTER_BUTTON' | translate }}
                    </span>
                  }
                </button>
              </form>

              <!-- Login Link -->
              <div class="auth-footer">
                <p>
                  {{ 'HAVE_ACCOUNT' | translate }}
                  <a routerLink="/login" class="login-link">{{ 'LOGIN_NOW' | translate }}</a>
                </p>
              </div>
            </div>
          </div>
